import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'
import * as MEDIA from 'styles/media-queries'

const { unit } = measures

export const loginContainer = css`
  display: flex;
  justify-content: center;

  width: 100%;
`

export const loginSection = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: ${unit}px;

  padding-top: ${3 * unit}px;
  padding-bottom: ${3 * unit}px;

  // background: linear-gradient(${colors.black100}, ${colors.grays.gray6});

  ${MEDIA.PHONES} {
    width: 100%;
  }
`

export const facebookSection = css`
  width: 60%;
`
